import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Slider from 'react-slick';
import TestimonialsCard from './TestimonialsCard';
import UserIcon from 'assets/img/profile/profileImage.jpg';
const testimonials = [
  {
    feedBack:
      'CRUD Beat has completely transformed our hiring and training process. The platform is seamless, and our placement success has skyrocketed. It’s a game-changer for both colleges and recruiters!',
    displayName: 'Vivek Raghunathan',
    userName: 'CEO, DigitalQ',
    image: UserIcon
  },
  {
    feedBack:
      'CRUD Beat revolutionized our recruitment process, making it faster, smarter, and more efficient. We’ve never had a tool this effective!',
    displayName: 'Director',
    userName: 'Mookambigai College of Engineering',
    image: UserIcon
  },
  {
    feedBack:
      'Our students’ placement rates have soared since adopting CRUD Beat. The platform’s assessments and features ensure they are industry-ready.',
    displayName: 'Director',
    userName: 'Bethlehem Institute of Engineering',
    image: UserIcon
  },
  {
    feedBack:
      'With CRUD Beat, our hiring decisions are more data-driven and precise. The platform has truly streamlined how we identify the best talent.',
    displayName: 'Jim Prinston',
    userName: 'IOPEX',
    image: UserIcon
  },
  {
    feedBack:
      'CRUD Beat bridges the gap between students and recruiters like never before. Its user-friendly interface and robust features make it an essential tool for any college or company.',
    displayName: 'Prabu',
    userName: 'Gratiture',
    image: UserIcon
  }
];

function Testimonials() {
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const settings = {
    customPaging: () => {
      return <div className="customCarousalThumb"></div>;
    },
    dots: true,
    dotsClass: 'slick-dots slick-thumb',
    infinite: true,
    speed: 3000,
    slidesToShow: isMobileScreen ? 1 : 3,
    slidesToScroll: 1,
    cssEase: 'linear',
    nextArrow: <></>,
    prevArrow: <></>,
    autoplay: true,
    autoplaySpeed: 5000
  };

  useEffect(() => {
    const windowSize = window.innerWidth;
    if (windowSize <= 650) {
      setIsMobileScreen(true);
    } else {
      setIsMobileScreen(false);
    }
  }, []);
  return (
    <Container className="py-14 testimonials" fluid>
      <p className="text-center text-secondary-dark">Testimonials</p>
      <p className="text-center fs-5 fw-bold">
        Transformative <span className="text-secondary-light">Client</span>{' '}
        Expectation
      </p>
      <div className="px-lg-8 testimonials_carousel">
        <Slider {...settings}>
          {Array.isArray(testimonials) &&
            testimonials.length > 0 &&
            testimonials.map((item, index) => (
              <div className="py-8" key={index}>
                <TestimonialsCard data={item} />
              </div>
            ))}
        </Slider>
      </div>
    </Container>
  );
}

export default Testimonials;
